module.exports = __webpack_public_path__ + "img/document.f72f9971.svg";